import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _jsx from "@babel/runtime/helpers/jsx";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["item", "classes", "favoriteCourses", "disableHover", "className", "auth", "isInDashboard", "intl", "cookies", "isCourseDownloading", "inOneColumn", "searchSessionId"];
var _dec, _dec2, _dec3, _class, _class2, _span, _span2;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import muiWithStyles from '@mui/styles/withStyles';
import { Cookies, withCookies } from 'react-cookie';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import Snackbar from '@mui/material/Snackbar';
import Tooltip from '@mui/material/Tooltip';
import Modal from '@mui/material/Modal';
import { Interweave } from 'interweave';
import AppContext from '../../context';
import * as authActions from '../../actions/auth';
import Link from '../Link';
import { buildQuery, getWhitelabeledOrganizationSlug, handleErroredImage } from '../../helpers';
import isLoggedIn from '../../helpers/checkAuth';
import formatLivestreamDate, { isSameDay } from '../../helpers/formatLivestreamDate';
import SkholeIcon02 from '../statelessComponents/Icons/SkholeIcon02';
import SkholeIcon03 from '../statelessComponents/Icons/SkholeIcon03';
import CircularProgressSmall from '../CircularProgressSmall';
import RestrictedAccessModal from '../RestrictedAccessModal/RestrictedAccessModal';
import s from './CourseItem.scss';
import intlPropTypes from '../../constants/intlPropTypes';
var messages = defineMessages({
  hasTaskLabel: {
    id: "CourseItem.hasTaskLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Task"
    }]
  },
  isFeaturedLabel: {
    id: "CourseItem.isFeaturedLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Featured"
    }]
  },
  removedSoonBadgeLabel: {
    id: "CourseItem.removedSoonBadgeLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Removed soon"
    }]
  },
  isNewLabel: {
    id: "CourseItem.isNewLabel",
    defaultMessage: [{
      "type": 0,
      "value": "New"
    }]
  },
  isCourseLabel: {
    id: "CourseItem.isCourseLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Course"
    }]
  },
  totalLessonsText: {
    id: "CourseItem.totalLessonsText",
    defaultMessage: [{
      "type": 0,
      "value": "lessons"
    }]
  },
  courseTimeText: {
    id: "CourseItem.courseTimeText",
    defaultMessage: [{
      "type": 0,
      "value": "("
    }, {
      "type": 1,
      "value": "hours"
    }, {
      "type": 0,
      "value": " h "
    }, {
      "type": 1,
      "value": "minutes"
    }, {
      "type": 0,
      "value": " min)"
    }]
  },
  courseTimeMinutesText: {
    id: "CourseItem.courseTimeMinutesText",
    defaultMessage: [{
      "type": 0,
      "value": "("
    }, {
      "type": 1,
      "value": "minutes"
    }, {
      "type": 0,
      "value": " min)"
    }]
  },
  courseIsDownloading: {
    id: "CourseItem.courseIsDownloading",
    defaultMessage: [{
      "type": 0,
      "value": "Downloading course \""
    }, {
      "type": 1,
      "value": "name"
    }, {
      "type": 0,
      "value": "\", related lessons and notes..."
    }]
  },
  courseIsDownloaded: {
    id: "CourseItem.courseIsDownloaded",
    defaultMessage: [{
      "type": 0,
      "value": "\""
    }, {
      "type": 1,
      "value": "name"
    }, {
      "type": 0,
      "value": "\" offline access download complete"
    }]
  },
  courseIsRemovedFromOffline: {
    id: "CourseItem.courseIsRemovedFromOffline",
    defaultMessage: [{
      "type": 0,
      "value": "Course \""
    }, {
      "type": 1,
      "value": "name"
    }, {
      "type": 0,
      "value": "\", related lessons and notes are removed from offline access"
    }]
  },
  browserDoesNotSupportCaching: {
    id: "CourseItem.browserDoesNotSupportCaching",
    defaultMessage: [{
      "type": 0,
      "value": "Your browser does not support offline caching. For better browsing experience, we recommend using Skhole with Google Chrome"
    }]
  },
  errorDuringCourseDownloading: {
    id: "CourseItem.errorDuringCourseDownloading",
    defaultMessage: [{
      "type": 0,
      "value": "Oops, error happened during updating cache: "
    }, {
      "type": 1,
      "value": "error"
    }]
  },
  courseIsDownloadingWarning: {
    id: "CourseItem.courseIsDownloadingWarning",
    defaultMessage: [{
      "type": 0,
      "value": "Course \""
    }, {
      "type": 1,
      "value": "name"
    }, {
      "type": 0,
      "value": "\" is still downloading for offline, are you sure you want to exit?"
    }]
  },
  saveForOffline: {
    id: "CourseItem.saveForOffline",
    defaultMessage: [{
      "type": 0,
      "value": "Download for offline"
    }]
  },
  removeFromOffline: {
    id: "CourseItem.removeFromOffline",
    defaultMessage: [{
      "type": 0,
      "value": "Remove from offline"
    }]
  },
  noAccess: {
    id: "CourseItem.noAccess",
    defaultMessage: [{
      "type": 0,
      "value": "You don’t have access to this content yet"
    }]
  },
  waitForCourseDownloading: {
    id: "CourseItem.waitForCourseDownloading",
    defaultMessage: [{
      "type": 0,
      "value": "It’s possible to download only one course at time. Please try again later."
    }]
  },
  addToFavourites: {
    id: "CourseItem.addToFavourites",
    defaultMessage: [{
      "type": 0,
      "value": "Add to favourites"
    }]
  },
  removeFromFavourites: {
    id: "CourseItem.removeFromFavourites",
    defaultMessage: [{
      "type": 0,
      "value": "Remove from favourites"
    }]
  },
  temporaryUnavailableOffline: {
    id: "CourseItem.temporaryUnavailableOffline",
    defaultMessage: [{
      "type": 0,
      "value": "Downloading is temporarily disabled due to maintenance."
    }]
  },
  pwaIsAboutToBeDisabled: {
    id: "General.pwaIsAboutToBeDisabled",
    defaultMessage: [{
      "type": 0,
      "value": "Removing this course from offline cache temporarily disables offline mode. All pages will reload"
    }]
  },
  confirm: {
    id: "General.confirmDisablePwa",
    defaultMessage: [{
      "type": 0,
      "value": "Confirm"
    }]
  },
  dismiss: {
    id: "General.dismissDisablePwa",
    defaultMessage: [{
      "type": 0,
      "value": "Dismiss"
    }]
  },
  courseType: {
    id: "General.courseType",
    defaultMessage: [{
      "type": 0,
      "value": "Course"
    }]
  },
  livestreamType: {
    id: "General.livestreamType",
    defaultMessage: [{
      "type": 0,
      "value": "livestream"
    }]
  },
  recordingType: {
    id: "General.recordingType",
    defaultMessage: [{
      "type": 0,
      "value": "recording"
    }]
  },
  podcastType: {
    id: "General.podcastType",
    defaultMessage: [{
      "type": 0,
      "value": "podcast"
    }]
  },
  streamingStartAt: {
    id: "General.streamingStartAt",
    defaultMessage: [{
      "type": 1,
      "value": "start"
    }, {
      "type": 0,
      "value": " - "
    }, {
      "type": 1,
      "value": "end"
    }]
  },
  streamingNowLive: {
    id: "General.streamingNowLive",
    defaultMessage: [{
      "type": 0,
      "value": "live"
    }]
  }
});
var styles = function styles(theme) {
  return {
    courseProgressRoot: {
      backgroundColor: '#F6F6F7',
      position: 'absolute',
      bottom: 0,
      width: '100%'
    },
    courseProgressBar: {
      backgroundColor: _.get(theme, 'palette.primary.light')
    }
  };
};
var CourseItem = (_dec = muiWithStyles(styles), _dec2 = withStyles(s), _dec3 = connect(function (state) {
  return {
    auth: state.auth,
    favoriteCourses: state.auth.favoriteCourses,
    lang: state.intl.locale,
    isCourseDownloading: state.online.isCourseDownloading
  };
}, function (dispatch) {
  return bindActionCreators({
    loadAuth: authActions.loadAuth,
    saveFavoriteCourses: authActions.saveFavoriteCourses
  }, dispatch);
}), injectIntl(_class = withCookies(_class = _dec(_class = _dec2(_class = _dec3(_class = (_class2 = /*#__PURE__*/function (_Component) {
  _inherits(CourseItem, _Component);
  var _super = _createSuper(CourseItem);
  function CourseItem() {
    var _this;
    _classCallCheck(this, CourseItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isCourseFavoriting: false,
      isOldBrowserWarning: false,
      isRestrictedAccessModalOpened: false
    });
    _defineProperty(_assertThisInitialized(_this), "getItemType", function () {
      var _this$props = _this.props,
        item = _this$props.item,
        formatMessage = _this$props.intl.formatMessage;
      var itemTypes = {
        course: formatMessage(messages.courseType),
        livestream: formatMessage(messages.livestreamType),
        podcast: formatMessage(messages.podcastType),
        recording: formatMessage(messages.recordingType)
      };
      if (!item.type || !_.has(itemTypes, item.type)) return itemTypes.course;
      return item.type === 'livestream' && moment().isAfter(item.liveStreamEnd) ? itemTypes.recording : itemTypes[item.type];
    });
    _defineProperty(_assertThisInitialized(_this), "closeRestrictedAccessModal", function () {
      _this.setState({
        isRestrictedAccessModalOpened: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "toggleFavorite", function (_id) {
      var _this$props2 = _this.props,
        favoriteCourses = _this$props2.favoriteCourses,
        saveFavoriteCourses = _this$props2.saveFavoriteCourses,
        afterCourseRemovedFromFavorite = _this$props2.afterCourseRemovedFromFavorite;
      _this.setState({
        isCourseFavoriting: true
      });
      if (favoriteCourses.includes(_id)) {
        return _this.context.fetch("/api/auth/favorite-courses/".concat(_id), {
          method: 'DELETE',
          headers: {
            'Content-Type': undefined,
            Accept: '*/*'
          }
        }).then(function () {
          return saveFavoriteCourses(_.without(favoriteCourses, _id));
        }).then(function () {
          _this.setState({
            isCourseFavoriting: false
          });
          afterCourseRemovedFromFavorite(_id);
        })["catch"](function (error) {
          console.error(error);
          _this.setState({
            isCourseFavoriting: false
          });
        });
      }
      return _this.context.fetch("/api/auth/favorite-courses/".concat(_id), {
        method: 'PUT',
        headers: {
          'Content-Type': undefined,
          Accept: '*/*'
        }
      }).then(function () {
        return saveFavoriteCourses(favoriteCourses.concat([_id]));
      }).then(function () {
        _this.setState({
          isCourseFavoriting: false
        });
      })["catch"](function (error) {
        console.error(error);
        _this.setState({
          isCourseFavoriting: false
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleCloseOldBrowserSnackbar", function () {
      _this.setState({
        isOldBrowserWarning: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "trackGACourseItemClick", function () {
      var _this$props3 = _this.props,
        item = _this$props3.item,
        auth = _this$props3.auth;
      if (window && window !== undefined) {
        var _auth$user, _auth$user$mainGroup, _auth$user2, _auth$user2$mainGroup;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'course_click',
          organization_slug: getWhitelabeledOrganizationSlug(auth) || null,
          organization_id: (auth === null || auth === void 0 ? void 0 : (_auth$user = auth.user) === null || _auth$user === void 0 ? void 0 : (_auth$user$mainGroup = _auth$user.mainGroup) === null || _auth$user$mainGroup === void 0 ? void 0 : _auth$user$mainGroup._id) || null,
          organization_name: (auth === null || auth === void 0 ? void 0 : (_auth$user2 = auth.user) === null || _auth$user2 === void 0 ? void 0 : (_auth$user2$mainGroup = _auth$user2.mainGroup) === null || _auth$user2$mainGroup === void 0 ? void 0 : _auth$user2$mainGroup.name) || null,
          is_course_public: (item === null || item === void 0 ? void 0 : item.isPublic) || false,
          course_name: item === null || item === void 0 ? void 0 : item.name,
          course_id: item === null || item === void 0 ? void 0 : item._id
        });
      }
    });
    return _this;
  }
  _createClass(CourseItem, [{
    key: "render",
    value: function render() {
      var _this2 = this,
        _classNames2,
        _classNames3,
        _classNames6,
        _classNames7,
        _classNames8,
        _classNames9;
      var _this$props4 = this.props,
        item = _this$props4.item,
        classes = _this$props4.classes,
        favoriteCourses = _this$props4.favoriteCourses,
        disableHover = _this$props4.disableHover,
        className = _this$props4.className,
        auth = _this$props4.auth,
        isInDashboard = _this$props4.isInDashboard,
        formatMessage = _this$props4.intl.formatMessage,
        cookies = _this$props4.cookies,
        isCourseDownloading = _this$props4.isCourseDownloading,
        inOneColumn = _this$props4.inOneColumn,
        searchSessionId = _this$props4.searchSessionId,
        rest = _objectWithoutProperties(_this$props4, _excluded);
      var _this$state = this.state,
        isCourseFavoriting = _this$state.isCourseFavoriting,
        isOldBrowserWarning = _this$state.isOldBrowserWarning,
        isRestrictedAccessModalOpened = _this$state.isRestrictedAccessModalOpened;
      var baseTime = item.manualDuration || item.time || 0;
      var timeMinutes = (baseTime || 0) % 60;
      var timeHours = ((baseTime || 0) - timeMinutes) / 60;
      var isCourseNew = !!item.publishedUpdatedDate && moment(item.publishedUpdatedDate).isValid() && moment().diff(moment(item.publishedUpdatedDate), 'days') <= 31;
      var isItemInFavoriteCourses = (favoriteCourses || []).includes(item._id);
      var getBadge = function getBadge() {
        if (isLoggedIn(auth) && item.hasTask) {
          return /*#__PURE__*/_jsx("div", {
            className: classNames(s.courseItemBadge, s.courseItemBadgeTask)
          }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.hasTaskLabel));
        }
        if (item.isFeatured && !item.hasTask && !item.liveStreamStart) {
          return /*#__PURE__*/_jsx("div", {
            className: classNames(s.courseItemBadge, s.courseItemBadgeFeatured)
          }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.isFeaturedLabel));
        }
        if (item.isStreamingNow) {
          return /*#__PURE__*/_jsx("div", {
            className: classNames(s.courseItemBadge, s.livestreamStartBadge)
          }, void 0, /*#__PURE__*/_jsx("span", {
            className: s.whitePoint
          }), /*#__PURE__*/React.createElement(FormattedMessage, messages.streamingNowLive));
        }
        if (item.type === 'livestream' && !item.isStreamingNow && moment().isBefore(item.liveStreamStart)) {
          return /*#__PURE__*/_jsx("div", {
            className: classNames(s.courseItemBadge, s.livestreamStartBadge)
          }, void 0, /*#__PURE__*/_jsx("span", {}, void 0, moment(item.liveStreamStart).format('D.M.YYYY HH:mm')));
        }
        if (isCourseNew && !item.isFeatured && !item.hasTask && !item.liveStreamStart) {
          return /*#__PURE__*/_jsx("div", {
            className: classNames(s.courseItemBadge, s.courseItemBadgeNew)
          }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.isNewLabel));
        }
        return null;
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Tooltip, {
        placement: "top",
        title: item.name
      }, void 0, /*#__PURE__*/React.createElement(Paper, _extends({
        "aria-label": item.name,
        className: classNames(s.courseItem, disableHover && s.disableHover, className, isInDashboard && s.inDashboard, !item.isAvailable && s.addonCourse, _defineProperty({}, s.inOneColumn, inOneColumn))
      }, _.omit(rest, ['afterCourseRemovedFromFavorite', 'saveFavoriteCourses', 'isCourseFavoriting', 'toggleNewVersionAvailableSnackbar', 'allCookies', 'swState']), {
        "data-test": "course-item",
        "data-test-value": item.name
      }), /*#__PURE__*/_jsx(ButtonBase, {
        onClickCapture: /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
            var type;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  // Have to check if onFavourite button click
                  // to prevent click to go Course detail page
                  type = e.target.dataset.type;
                  if (!type && e.target.closest('[data-type="favorite"]')) {
                    type = 'favorite';
                  }
                  if (!['favorite'].includes(type)) {
                    _context.next = 8;
                    break;
                  }
                  e.stopPropagation();
                  e.preventDefault();
                  if (!(type === 'favorite' && isCourseFavoriting)) {
                    _context.next = 7;
                    break;
                  }
                  return _context.abrupt("return");
                case 7:
                  if (type === 'favorite' && !isCourseFavoriting) {
                    _this2.toggleFavorite(item._id);
                  }
                case 8:
                  _this2.trackGACourseItemClick();
                case 9:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }(),
        component: Link,
        to: "/courses/".concat(item.slug, "?").concat(buildQuery({
          searchSessionId: searchSessionId
        })),
        className: classNames(s.courseItemLink, (_classNames2 = {}, _defineProperty(_classNames2, s.inDashboard, isInDashboard), _defineProperty(_classNames2, s.inOneColumn, inOneColumn), _classNames2))
        // disabled={isCourseFavoriting || isSavingForOffline}
        ,
        focusRipple: true
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: classNames(s.imgWrapper, (_classNames3 = {}, _defineProperty(_classNames3, s.inDashboard, isInDashboard), _defineProperty(_classNames3, s.inOneColumn, inOneColumn), _classNames3))
      }, void 0, getBadge(), !!item.autoHideDate && /*#__PURE__*/_jsx("div", {
        className: classNames(s.courseItemBadge, s.courseItemBadgeRemovedSoon, _defineProperty({}, s.secondBadge, !!getBadge()))
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.removedSoonBadgeLabel)), /*#__PURE__*/_jsx("img", {
        src: "".concat(this.context.cloudfrontUrl, "/").concat(_.get(item, 'thumbnail.path', 'default.svg')),
        alt: item.name,
        className: classNames(s.courseItemImage, _defineProperty({}, s.inDashboard, isInDashboard)),
        onError: handleErroredImage
      })), /*#__PURE__*/_jsx("div", {
        className: classNames(s.courseItemTextDataWrapper, (_classNames6 = {}, _defineProperty(_classNames6, s.inDashboard, isInDashboard), _defineProperty(_classNames6, s.inOneColumn, inOneColumn), _classNames6))
      }, void 0, /*#__PURE__*/_jsx(Typography, {
        className: s.itemType,
        component: "div"
      }, void 0, _.toUpper(this.getItemType())), /*#__PURE__*/_jsx(Typography, {
        variant: "h2",
        className: classNames(s.courseItemTitle, (_classNames7 = {}, _defineProperty(_classNames7, s.inDashboard, isInDashboard), _defineProperty(_classNames7, s.inOneColumn, inOneColumn), _classNames7)),
        "data-test": "course-name"
      }, void 0, /*#__PURE__*/_jsx(Interweave, {
        content: item.name,
        tagName: "div",
        className: classNames(s.courseItemTitleHTMLContent, (_classNames8 = {}, _defineProperty(_classNames8, s.inOneLine, inOneColumn), _defineProperty(_classNames8, s.inTwoLine, !inOneColumn), _classNames8))
      })), inOneColumn && /*#__PURE__*/_jsx("div", {
        className: s.description
      }, void 0, /*#__PURE__*/_jsx(Interweave, {
        content: item.shortDescription,
        noWrap: true
      })), /*#__PURE__*/_jsx("div", {
        className: classNames(s.courseItemDetails, (_classNames9 = {}, _defineProperty(_classNames9, s.inDashboard, isInDashboard), _defineProperty(_classNames9, s.inOneColumn, inOneColumn), _classNames9))
      }, void 0, _.get(item, 'type') !== 'livestream' && /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle1",
        className: classNames(s.courseItemDetailsStats, _defineProperty({}, s.inDashboard, isInDashboard)),
        component: "div"
      }, void 0, item.totalLessons, _span || (_span = /*#__PURE__*/_jsx("span", {}, void 0, "\xA0")), /*#__PURE__*/React.createElement(FormattedMessage, messages.totalLessonsText), _span2 || (_span2 = /*#__PURE__*/_jsx("span", {}, void 0, "\xA0")), /*#__PURE__*/_jsx("span", {
        className: s.hideInSmallMobile
      }, void 0, !!baseTime && /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, timeHours > 0 ? messages.courseTimeText : messages.courseTimeMinutesText, {
        values: {
          hours: timeHours,
          minutes: timeMinutes
        }
      })))), item.type === 'livestream' && /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle1",
        className: classNames(s.courseItemDetailsStats, _defineProperty({}, s.inDashboard, isInDashboard)),
        component: "div"
      }, void 0, isSameDay(item.liveStreamStart, item.liveStreamEnd) && moment().isAfter(item.liveStreamEnd) ? formatLivestreamDate(item.liveStreamStart) : /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.streamingStartAt, {
        values: formatLivestreamDate(item.liveStreamStart, item.liveStreamEnd, moment().isAfter(item.liveStreamEnd))
      }))), /*#__PURE__*/_jsx("div", {
        className: classNames(s.actions, 'course-item-actions', _defineProperty({}, s.livestreamActions, item.type === 'livestream'))
      }, void 0, isLoggedIn(auth) && item.isAvailable && /*#__PURE__*/_jsx("div", {
        className: s.relative,
        "data-type": "favorite"
      }, void 0, /*#__PURE__*/_jsx(Checkbox, {
        "data-test-id": "XIP10CR0iysKcXXo9ODnn",
        className: s.favouriteRoot
        // disabled={isCourseFavoriting}
        ,
        checked: isItemInFavoriteCourses,
        onClick: function onClick() {
          return _this2.toggleFavorite(item._id);
        },
        color: "primary",
        icon: /*#__PURE__*/_jsx(SkholeIcon03, {
          style: {
            fontSize: 20
          }
        }),
        checkedIcon: /*#__PURE__*/_jsx(SkholeIcon02, {
          style: {
            fontSize: 20
          }
        }),
        inputProps: {
          'data-type': 'favorite',
          'aria-label': formatMessage(isItemInFavoriteCourses ? messages.removeFromFavourites : messages.addToFavourites)
        }
      }), isCourseFavoriting && /*#__PURE__*/_jsx(CircularProgressSmall, {
        wrapperClassName: s.cacheUpdatingProgress
      })))))), !!item.progress && /*#__PURE__*/_jsx(LinearProgress, {
        variant: "determinate",
        value: item.progress,
        color: "primary",
        classes: {
          root: classes.courseProgressRoot,
          barColorSecondary: classes.courseProgressBar
        }
      }))), /*#__PURE__*/_jsx(Snackbar, {
        open: isOldBrowserWarning,
        onClose: this.handleCloseOldBrowserSnackbar,
        autoHideDuration: 3000,
        message: formatMessage(messages.browserDoesNotSupportCaching)
      }), /*#__PURE__*/_jsx(Modal, {
        open: isRestrictedAccessModalOpened,
        onClose: this.closeRestrictedAccessModal
      }, void 0, /*#__PURE__*/_jsx(RestrictedAccessModal, {
        onClose: this.closeRestrictedAccessModal
      })));
    }
  }]);
  return CourseItem;
}(Component), _defineProperty(_class2, "defaultProps", {
  isCourseFavoriting: false,
  afterCourseRemovedFromFavorite: function afterCourseRemovedFromFavorite() {
    return null;
  },
  disableHover: false,
  isInDashboard: false,
  className: '',
  searchSessionId: ''
}), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class) || _class) || _class) || _class);
export { CourseItem as default };